import { FormControl, FormHelperText, InputLabel, LinearProgress, MenuItem } from '@material-ui/core'
import { ErrorMessage, Field, useFormikContext } from 'formik'
import { Select } from 'formik-material-ui'
import React, { memo, useEffect, useState } from 'react'

import { getAxiosInstance } from '../../../../../../../../helpers/get_axios_instance'
import { lrsAdapter } from '../../../../../../../../helpers/lrs_adapter'

const getSilosPosiblesDeAnularTransile = async (siloOrigen) =>
  lrsAdapter(
    await getAxiosInstance().get('/ultimo_transile_silo', {
      params: { r: { clave: { silo_origen: siloOrigen.trim() } } }
    })
  )

export const SiloDestinoParaAnularTransileSelect = memo(({ siloOrigen }) => {
  const [posiblesDestinos, setPosiblesDestinos] = useState([])
  const [loadingSilos, setLoadingSilos] = useState(true)
  useEffect(() => {
    (async () => {
      setPosiblesDestinos((await getSilosPosiblesDeAnularTransile(siloOrigen)).data)
      setLoadingSilos(false)
    })()
  }, [setPosiblesDestinos, setLoadingSilos, siloOrigen])
  const {
    errors: { siloDestino: error }
  } = useFormikContext()
  return (
    <FormControl style={{ width: '100%' }} variant='outlined' error={!!error}>
      <InputLabel id='siloDestino-label'>Silo Destino</InputLabel>
      <Field
        component={Select}
        name='siloDestino'
        label='Silo Destino'
        inputProps={{
          labelId: 'siloDestino-label',
          id: 'siloDestino'
        }}
      >
        {(posiblesDestinos || []).map(({ siloDestino }) => (
          <MenuItem key={siloDestino} value={siloDestino}>
            {siloDestino}
          </MenuItem>
        ))}
      </Field>
      {loadingSilos && <LinearProgress />}
      <ErrorMessage name='siloDestino'>{(error) => <FormHelperText>{error}</FormHelperText>}</ErrorMessage>
    </FormControl>
  )
})
